import { render, staticRenderFns } from "./Taxi.vue?vue&type=template&id=8fed5112&lang=pug"
import script from "./Taxi.vue?vue&type=script&lang=js"
export * from "./Taxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports